module.exports = __webpack_public_path__ + "dcf66a9d23972afef3ea9e336a152fea.mp3";